<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
		<agenteaduana-modals
			:modelName="modelName"
		></agenteaduana-modals>
	</div>
</template>

<script>
import agenteaduanaActions from './AgenteaduanaActions';
import agenteaduanaModals from './AgenteaduanaModals.vue';

export default {
	name: 'agenteaduana-grid',
	components: {
		'agenteaduana-modals': agenteaduanaModals
	},
	data() {
		return {
			modelName: 'agenteaduana',
			actions: agenteaduanaActions.gridactions,
			modelColumnDefs: {
			}
		}
	}
}
</script>
